import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from "@angular/core";
import {AppService} from "@irb/app.service";
import {CalltoactionService} from "@irb/irb-common/components/calltoaction/calltoaction.service";
import {IEvent, IrbAppEvents, IrbModelsEvents} from "@irb/irb-common/events";
import {UtilityService} from "@irb/irb-common/services/utility.service";
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {HarvestTaxLossRebalanceGridLayoutService} from "./harvest-tax-loss-rebalance.grid-layout.service";
import {Subscription} from "rxjs";
import {IDropdownItem} from '@irb-common/models/dropdown.model';
import {DropdownSearchMultipleComponent} from '@irb-common/components/dropdown-search-multiple/dropdown-search-multiple.component';
import {DropdownFilterComponent} from "@irb/irb-common/components/dropdown-filter/dropdown-filter.component";

@Component({ standalone: false,
  selector: "irb-harvest-tax-loss-rebalance-setting",
  templateUrl: "./harvest-tax-loss-rebalance-setting.component.html",
  styleUrls: [
    "./harvest-tax-loss-rebalance-setting.component.scss"
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ComHarvestTaxLossRebalanceSettingComponent implements OnInit, OnDestroy {
  @ViewChild('harvestedSecuritiesDropdown') harvestedSecuritiesDropdown: DropdownSearchMultipleComponent;
  @ViewChild('harvestedSecuritiesSameWayAsDropdown') harvestedSecuritiesSameWayAsDropdown: DropdownFilterComponent;
  @ViewChild("replaceSecDropDown") replaceSecDropDown: any;
  @Output() change = new EventEmitter<boolean>();
  @Output() navigate = new EventEmitter<number>();
  @Input() analysisType = "";

  grid: any;
  gridOptions: any;
  rowCount: any = 0;
  _isModified: boolean = false;
  htlTargets: any = [];
  harvestTaxLossTypeDropdown: IDropdownItem[] = [];
  securityTargetData: any;
  securitiesTargets: Array<IDropdownItem> = [];
  securitiesTargetsGrid: Array<IDropdownItem> = [];
  selectedSecToAdd: Array<any>;
  percentAmount: any = 0;
  dollarAmount: any = 0;
  tooltipMessage: string;
  toolTipShow: boolean;
  toolTipShowPercent: boolean;
  tooltipMessagePercent: string;
  toolTipShowDollar: boolean;
  tooltipMessageDollar: string;
  regExpPercent: RegExp = /^(?:\d*\.\d{1,2}|\d+)$/;
  selectedReplaceSec: any;
  eventSubscription: Subscription;
  securitiesTargetsSelected: Array<IDropdownItem> = [];
  addNewSecurityItem: any = {
    button: 'Add new security',
    type: 'security',
    fromComp: 'ComHarvestTaxLossRebalanceSettingComponent'
  };
  showAutoFocus: boolean = false;
  isReadOnlyClear: boolean = true;
  originalData: any;
  frameworkComponents: unknown;
  isUiTest = false;
  constructor(
    private ies: IrbEditorsService,
    private util: UtilityService,
    private as: AppService,
    private harvestTaxLossRebalanceGridLayoutService: HarvestTaxLossRebalanceGridLayoutService,
    private ctas: CalltoactionService
  ) {
  }

  _data: any;

  @Input()
  get data(): any {
    return this._data;
  }

  set data(d: any) {
    this._data = d;
    this.originalData = this.util.clone(d);
  }

  _isReadOnly: boolean = false;

  @Input()
  get isReadOnly(): any {
    return this._isReadOnly;
  }

  set isReadOnly(d: any) {
    this._isReadOnly = d;
  }

  ngOnInit() {
    this.frameworkComponents = this.harvestTaxLossRebalanceGridLayoutService.getFrameworkComponents() || {};
    this.gridOptions = {
      columnDefs: this.isReadOnly ? this.harvestTaxLossRebalanceGridLayoutService.getDisabledColumnDefs(this) : this.harvestTaxLossRebalanceGridLayoutService.getColumnDefs(this),
      floatingFilter: false,
      overlayNoRowsTemplate:
        "<span class='ag-overlay-loadGriding-center ag-overlay-message'>No Securities assigned</span>",
      context: {componentParent: this},
      suppressCellFocus: this.isReadOnly,
      isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
      doesExternalFilterPass: this.doesExternalFilterPass.bind(this)
    };

    this.toolTipShow = false;
    this.tooltipMessage = "";
    this.toolTipShowDollar = false;
    this.tooltipMessageDollar = "";
    this.tooltipMessagePercent = "";
    this.toolTipShowPercent = false;

    this.ies.getTaxLossHarvestDetail().subscribe((data: any) => {
      data.responseData?.items.forEach((item: any) => {
        this.harvestTaxLossTypeDropdown.push({
          name: item.name,
          value: item.id
        });
      });
    });
    this.ies.getTaxLossSecuritiesDropDown().subscribe((data: any) => {
      this.loadSecuritiesDropdown(data);
    });
    this.eventSubscription = this.as.getEvents().subscribe((s) => {
      this.processEvent(s);
    });
  }

  ngOnDestroy() {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }

  filterSecurities(searchString: string): void {
    this.harvestedSecuritiesDropdown.set(
      DropdownFilterComponent.getFilteredList(searchString,this.securitiesTargets)
        .map(security => ({
          name: security.name,
          value: security.value
        }))
    );
  }

  processEvent(event: IEvent) {
    switch (event.type) {
      case IrbModelsEvents.SAVE_CREATE_NEW_SECURITY:
        if (event.data) {
          if (event.data.type === 'security' && event.data.fromComp === 'ComHarvestTaxLossRebalanceSettingComponent' || event.data.fromComp === 'HarvestTaxLossRebalanceGridLayoutService') {
            const forGrid: boolean = event.data.fromComp === 'HarvestTaxLossRebalanceGridLayoutService' ? true : false;
            this.resetSecuritySearch(event.data, forGrid);
          }
        }
        break;
      case IrbModelsEvents.SAVE_MASTER_MULTIPLE_SECURITY:
        if (event.data && event.data.type === 'rebalance') {
          this.updateWithMultipleSecurity(event.data);
        }
        break;
    }
  }

  updateWithMultipleSecurity(event: any) {
    let addedSecurities = event.selectedSecurities;
    let dupElms: any = [];

    if (addedSecurities && addedSecurities.length) {
      this.showAutoFocus = addedSecurities.length === 1;
    }

    addedSecurities.forEach((security: any) => {
      let secToBeAdded = {
        dollarAmount: 0,
        harvestSecId: security.securityId,
        harvestSecSymb: security.securitySymbol,
        harvestSecType: security.securityType,
        isUIdeleted: false,
        isNew: true,
        percentageAmount: 0,
        replaceSecId: -2,
        replaceSecSymb: ""
      };
      if (this.data.harvestTaxLossDto.htlSecsdtoList) {
        if (this.data.harvestTaxLossDto.htlSecsdtoList.some((existSec: any) => {
          return existSec.harvestSecId === security.securityId;
        })) {
          dupElms.push(security)
        } else {
          this.data.harvestTaxLossDto.htlSecsdtoList.push(secToBeAdded);
        }
      } else {
        this.data.harvestTaxLossDto.htlSecsdtoList = [];
        this.data.harvestTaxLossDto.htlSecsdtoList[0] = secToBeAdded;
      }
    });

    this.loadGrid();
    this.change.emit(this.data);
  }

  loadHtlDropDown(data: any) {
    for (let i = 0; i < data.items.length; i++) {
      this.htlTargets.push({label: data.items[i].name, value: data.items[i].id});
    }
  }

  loadSecuritiesDropdown(data: any) {
    this.securityTargetData = data.items;
    for (let i = 0; i < data.items.length; i++) {
      this.securitiesTargets.push({name: data.items[i].securitySymbol, value: data.items[i].securityId});
      this.securitiesTargetsGrid.push({name: data.items[i].securitySymbol, value: data.items[i].securityId});
    }
  }

  filterReplaceSecDropDown(params: any) {
    return this.securitiesTargetsGrid.filter((elem: any) => elem === params.data.harvestSecSymb);
  }

  onHtlChange(event: any) {
    let htlCloneData = {cloneId: event.value};
    this.isReadOnlyClear = false;
    this.ies.getTaxLossHarvestClone(htlCloneData).subscribe((data: any) => {
      if (data.isLotLevel === true) {
        this.data.harvestTaxLossDto.isLotLevel = true;
      } else {
        this.data.harvestTaxLossDto.isLotLevel = false;
      }
      this.data.harvestTaxLossDto.htlSecsdtoList = data.htlSecsdtoList;
      this.loadGrid();
      this.change.emit(this.data);
    });

  }

  setChainTypeOptions(searchStr: any) {
    this.harvestedSecuritiesSameWayAsDropdown.set(DropdownFilterComponent.getFilteredList(searchStr,this.harvestTaxLossTypeDropdown));
  }

  validatePercentage() {
    if (!this.regExpPercent.test(this.percentAmount)) {
      return false;
    }
    if (parseFloat(this.percentAmount) > 100.0) {
      return false;
    }
    this.toolTipShowPercent = false;
    return true;
  }

  validateDollar() {
    if (!this.regExpPercent.test(this.dollarAmount)) {
      return false;
    } else {
      return true;
    }
  }

  onPercentAmountApply() {
    if (this.validatePercentage()) {
      (this.data.harvestTaxLossDto.htlSecsdtoList) ? this.data.harvestTaxLossDto.htlSecsdtoList.forEach((element: any) => {
        element.percentageAmount = this.percentAmount;
      }) : null;
      this.loadGrid();
      this.change.emit(this.data);
    }

  }

  onDollarAmountApply() {
    if (this.validateDollar()) {
      (this.data.harvestTaxLossDto.htlSecsdtoList) ? this.data.harvestTaxLossDto.htlSecsdtoList.forEach((element: any) => {
        element.dollarAmount = this.dollarAmount;
      }) : null;
      this.loadGrid();
      this.change.emit(this.data);
    }

  }

  onPercentChange() {
    this.tooltipMessagePercent = "";
    this.toolTipShowPercent = false;
  }

  onDollarChange() {
    this.tooltipMessageDollar = "";
    this.toolTipShowDollar = false;
  }

  onReplaceSecurityChange(event: any) {

    this.selectedReplaceSec = event.originalEvent.target.innerText;

  }

  onReplacewithApply() {
    let replacesecType = "";
    this.securityTargetData.forEach((element: any) => {
      if (element.securitySymbol === this.selectedReplaceSec) {
        replacesecType = element.securityType;
      }
    });
    (this.data.harvestTaxLossDto.htlSecsdtoList) ? this.data.harvestTaxLossDto.htlSecsdtoList.forEach((element: any) => {
      element.replaceSecSymb = this.selectedReplaceSec;
      element.replaceSecType = replacesecType;
    }) : null;
    this.loadGrid();
    this.change.emit(this.data);
  }

  checkDuplicateSecurity(item: any) {

    if (this.data.harvestTaxLossDto.htlSecsdtoList) {
      let selectedSecid = item.harvestSecId;
      return this.data.harvestTaxLossDto.htlSecsdtoList.some((elem: any) => {
        return elem.harvestSecId === selectedSecid;
      });
    } else {
      return false;
    }
  }

  addSecurity() {
    this.tooltipMessage = "";
    let dupelems: any = [];
    this.selectedSecToAdd.forEach((item: any) => {
      if (item && !this.checkDuplicateSecurity(item)) {
        if (this.data.harvestTaxLossDto.htlSecsdtoList) {
          this.data.harvestTaxLossDto.htlSecsdtoList.push(item);
        } else {
          this.data.harvestTaxLossDto.htlSecsdtoList = [];
          this.data.harvestTaxLossDto.htlSecsdtoList[0] = item;
        }
      } else {
        this.data.harvestTaxLossDto.htlSecsdtoList.forEach((newsec: any) => {
          dupelems.push(newsec);
        });
      }
    });
    if (dupelems.length > 0) {
      this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
        severity: "warn",
        summary: "",
        detail: "Security(ies) cannot be listed twice.",
      });
    }
    if (this.data.harvestTaxLossDto.htlSecsdtoList.length > 0) {
        //this.showAutoFocus = this.data.harvestTaxLossDto.htlSecsdtoList.length === 1;
      this.loadGrid();
      this.change.emit(this.data);
      this.harvestedSecuritiesDropdown.clear();
    }
  }

  disableAddHarvestSec() {
    return this.securitiesTargetsSelected !== null && this.securitiesTargetsSelected.length > 0;
  }

  captureAddSecurity(event: Array<IDropdownItem>) {
    let harvestSecType = "";
    this.selectedSecToAdd = [];

    event && event.forEach((item: IDropdownItem) => {
      this.securityTargetData.forEach((element: any) => {
        if (element.securitySymbol === item.name) {
          harvestSecType = element.securityType;
        }
      });

      this.selectedSecToAdd.push({
        dollarAmount: 0,
        harvestSecId: item.value,
        harvestSecSymb: item.name,
        harvestSecType: harvestSecType,
        isUIdeleted: false,
        isNew: true,
        percentageAmount: 0,
        replaceSecId: -2,
        replaceSecSymb: "",
        isSwapExchange: false
      });
    });


  }

  onLotLevelChange(event: any) {
    this.data.harvestTaxLossDto.isLotLevel = event.target.checked;
    this.change.emit(this.data);
  }

  onPositionLevelChange() {
    this.change.emit(this.data);
  }

  onGridReady(params: any) {
    this.grid = params;
    this.loadGrid();
  }

  loadGrid() {
    //if(this.data.harvestTaxLossDto.htlSecsdtoList) {
    this.grid.api.setGridOption('rowData', this.data.harvestTaxLossDto.htlSecsdtoList);
    this.rowCount = this.getRowCount();
      //this.grid.api.sizeColumnsToFit();
    //}
  }

  refreshGrid() {
    this.grid.api.deselectAll();
    this.grid.api.hideOverlay();
  }

  deleteAll() {
    for (let i = 0; i < this.data.harvestTaxLossDto.htlSecsdtoList.length; i++) {
      this.data.harvestTaxLossDto.htlSecsdtoList[i].isUIdeleted = true;
    }
    this.data.harvestTaxLossDto.htlSecsdtoList = this.data.harvestTaxLossDto.htlSecsdtoList.filter((x: any) => !(x.isNew && x.isUIdeleted));
    this.refreshGrid();
    this.loadGrid();
    this.change.emit(this.data);
  }

  delete(cc: any) {
    for (let i = 0; i < this.data.harvestTaxLossDto.htlSecsdtoList.length; i++) {
      if (this.data.harvestTaxLossDto.htlSecsdtoList[i].harvestSecId === cc.harvestSecId) {
        this.data.harvestTaxLossDto.htlSecsdtoList[i].isUIdeleted = true;
        break;
      }
    }
    this.data.harvestTaxLossDto.htlSecsdtoList = this.data.harvestTaxLossDto.htlSecsdtoList.filter((x: any) => !(x.isNew && x.isUIdeleted));
    this.loadGrid();
    this.change.emit(this.data);
  }

  cancelDelete() {
    this.ctas.remove();
  }

  showAddMultipleSecuritiesDialog() {
    let dataInputForMultipleSelection: any = [];
    this.grid.api.forEachNode(function (node: any) {
      if (!node.data.isUIdeleted)
        dataInputForMultipleSelection.push(node.data);
    });
    const params = {
      type: 'rebalance',
      field: "harvestSecId",
      data: dataInputForMultipleSelection,
      noDollarcash: true
    };
    this.as.fireEvent(IrbModelsEvents.SHOW_MASTER_MULTIPLE_SECURITY, params);
  }

  getRowCount() {
    return (this.data.harvestTaxLossDto && this.data.harvestTaxLossDto.htlSecsdtoList) ? this.data.harvestTaxLossDto.htlSecsdtoList.filter((x: any) => x.isUIdeleted === false).length : 0;
  }

  isExternalFilterPresent() {
    return true;
  }

  doesExternalFilterPass(node: any) {
    return !node.data.isUIdeleted;
  }

  warnIfSymbolUsedAsEquityReplaceTarget(replacedSymbol: string) {
    if (this.checkIfSymbolUsedAsEquityReplaceTarget(replacedSymbol)) {
      const rn: any = [];
      let disabledSwapExchCount = 0;

      this.grid.api.forEachNode((node: any) => {
        if (node.data.replaceSecSymb === replacedSymbol) {
          if (node.data.isSwapExchange) {
            node.data.isSwapExchange = false;
            disabledSwapExchCount++;
          }

          rn.push(node);
        }
      });

      if (rn.length > 0) {
        this.grid.api.redrawRows({rowNodes: rn});

        if (disabledSwapExchCount > 0) {
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: "warn",
            summary: "Fund " + replacedSymbol + " is already listed as a replacement buy security.",
            detail: "The Swap/Exch checkbox has been unchecked to be consistent with all replacement securities.",
            sticky: true
          });
        }
      }
    }
  }

  checkIfSymbolUsedAsEquityReplaceTarget(replacedSymbol: string) {
    const f = this.data.harvestTaxLossDto.htlSecsdtoList.find((x: any) => x.harvestSecType !== "MUTUAL_FUND" && x.replaceSecSymb === replacedSymbol);
    return (f) ? true : false;
  }

  openNewItemSecurityFlow(dataParam: any, forGrid: boolean) {
    if (!forGrid) {
      dataParam = Object.assign({}, this.addNewSecurityItem, dataParam);
      }
      this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_SECURITIES, dataParam);
  }

  resetSecuritySearch(dataParam: any,forGrid: boolean) {
    if (dataParam && dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {

      this.securitiesTargets = this.securitiesTargets.concat(dataParam.newItemsForDD);
      this.securitiesTargetsGrid = this.securitiesTargetsGrid.concat(dataParam.newItemsForDD);

      let newItem: any;
      dataParam.securities.responseData.forEach((newSec: any) => {
        newItem = {
          securityDescription: newSec.securityDescription,
          securityId: newSec.securityId,
          securitySymbol: newSec.securitySymbol,
          securityType: newSec.securityType
        };
        this.securityTargetData.push(newItem);
      });
      if(!forGrid){
        this.harvestedSecuritiesDropdown.setValue(dataParam.newItemsForDD);
        this.captureAddSecurity(dataParam.newItemsForDD);
      }else{
        const rowIndex: number = dataParam.rowIndex;
                if (rowIndex !== null || typeof rowIndex !== "undefined") {
                    this.grid.api.forEachNode((node: any) => {
                        if (node.rowIndex === rowIndex) {
                            node.data.replaceSecSymb = dataParam.newItemsForDD[0].name;
                            node.data.securityId = dataParam.newItemsForDD[0].value;
                        }
                    });
                    const n = this.grid.api.getDisplayedRowAtIndex(rowIndex);
                    this.grid.api.redrawRows({rowNodes: [n]});
                }
      }

      this.ies.getTaxLossSecuritiesDropDown().subscribe((data: any) => {
        this.securitiesTargets = [];
        this.securitiesTargetsGrid = [];
        this.loadSecuritiesDropdown(data);
      });
    }
  }
  onClearTaxLossToClone(){
    this.harvestedSecuritiesSameWayAsDropdown?.setValue(null);
    this.data.harvestTaxLossDto.isLotLevel = false;
    this.data.harvestTaxLossDto.htlSecsdtoList = [];
    this.isReadOnlyClear = true;
    this.loadGrid();
    this.change.emit(this.data);
  }
}
